<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="22">
            <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model.trim="queryParam.keyWord" />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="22">
            <a-form-item label="类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 5px">
              <a-select v-model.trim="queryParam.type" @change="installChange" :allowClear="false">
                <a-select-option v-for="type in trainType" :title="type.dictLabel" :key="type.dictValue">{{
                type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="22">
            <a-form-item label="品牌" style="margin-left: 56px" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select showSearch optionFilterProp="children" @change="changeBrandName" :filterOption="filterOption"
                v-model="queryParam.brandId" :allowClear="true">
                <a-select-option v-for="type in selectBrand" :title="type.brandName" :key="type.brandId">{{
                type.brandName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="22">
            <a-form-item label="型号" style="margin-left: 56px" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select showSearch optionFilterProp="children" @change="changeModelName" :filterOption="filterOption"
                v-model="queryParam.modelId" :allowClear="true">
                <a-select-option v-for="type in selectModel" :title="type.modelName" :key="type.modelId">{{
                type.modelName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="22">
            <a-form-item label="审核状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 5px">
              <a-select v-model.trim="queryParam.releaseStatus" :allowClear="true">
                <a-select-option v-for="type in trainReleaseStatus" :title="type.dictLabel" :key="type.dictValue">{{
                type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="22">
            <a-form-item label="创建开始日期" style="margin-left: 5px">
              <a-date-picker v-model="queryParam.time1" style="width:100%" show-time :disabled-date="disabledStartDate"
                format="YYYY-MM-DD" @change="onChange1" @ok="onOk1" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="22">
            <a-form-item label="创建结束日期">
              <a-date-picker v-model="queryParam.time2" style="width:100%" show-time :disabled-date="disabledEndDate"
                format="YYYY-MM-DD" @change="onChange2" @ok="onOk2" />
            </a-form-item>
          </a-col>

          <a-col :span="22" style="text-align: right;margin-right: 8px">
            <a-button type="primary" htmlType="submit" style="margin-right: 8px" @click="query(1)">查询</a-button>
            <a-button style="margin-left: 8px" @click="() => (queryParam = {}) && getList()">清空</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4" :offset="20" style="text-align: right">
            <a-button type="primary" icon="plus" @click="$refs.modal.add()">新增</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator"></div>
    <a-table size="default" rowKey="id" :columns="columns" :data-source="loadData" bordered :customRow="customRow"
      :pagination="false">
      <span slot="action" slot-scope="text, record">
        <a v-if="record.releaseStatus == 0" @click="handleEdit(record)">修改</a>
        <a-divider v-if="record.releaseStatus == 0" type="vertical" />
        <a v-if="record.releaseStatus == 0 && record.type != 7" @click="handlePubulish(record)">发布</a>
        <a-divider v-if="record.releaseStatus == 0 && record.type != 7" type="vertical" />
        <a v-if="record.releaseStatus == 1 && record.type != 7" @click="cancel(record)">撤销</a>
        <a-divider v-if="record.releaseStatus == 1 && record.type != 7" type="vertical" />
        <a color="blue" @click="handleInfo(record)">详情</a>
        <a-divider type="vertical" />
        <a color="blue" @click="delTrain(record.trainId)">删除</a>
      </span>
    </a-table>
    <a-pagination showQuickJumper="true" showSizeChanger :pageSizeOptions="pageSizeOptions" :pageSize.sync="pageSize"
      @showSizeChange="onShowSizeChange" :total="total" v-model="current" @change="changePage"
      :showTotal="total => `总共 ${total} 条`" style="text-align: right; margin-top: 20px" />
    <trainEdit ref="modal" @ok="handleOk" />
  </a-card>
</template>

<script>
import { STable } from '@/components'
import pick from 'lodash.pick'
import moment from 'moment'
import { queryList, trainUpdate, updateIndexIdSort, delTrainList } from '@/api/trainOverview/trainList'
import trainEdit from './modules/add.vue'
import { checkPermission } from '@/utils/permissions'
import NoAuthority from '../enterprise/NoAuthority'
import { getfinddictAll, getSelectBrand, getSelectModel } from '@/api/order/orderList'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { Tooltip } from 'ant-design-vue'

export default {
  name: 'TableList',
  components: {
    STable,
    trainEdit,
    NoAuthority
  },
  data() {
    return {
      data: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      bisible: false,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 字典为安装类型
      trainType: [],
      selectBrand: [],
      trainReleaseStatus: [],
      // 查询型号下拉框
      selectModel: [],
      // 表头
      columns: [
        {
          title: '操作',
          width: '60px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '标题',
          align: 'center',
          dataIndex: 'title'
        },
        {
          title: '类型',
          align: 'center',
          dataIndex: 'typeName'
        },
        {
          width: 120,
          title: '品牌名称',
          dataIndex: 'brandName',
          align: 'center',
          customRender: text => (
            <a-tooltip class="tableItem" title={text}>
              {text}
            </a-tooltip>
          )
        },
        {
          title: '型号名称',
          dataIndex: 'modelName',
          align: 'center',
          width: 120,
          customRender: text => (
            <a-tooltip class="tableItem" title={text}>
              {text}
            </a-tooltip>
          )
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'releaseStatusName'
        },

        {
          title: '创建日期',
          align: 'center',
          dataIndex: 'createTime'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: [],
      selectedRowKeys: [],
      selectedRows: [],
      startIndex: null, // 选择需要拖拽的index
      startIndexId: null, // 选择需要拖拽的indexId
      endIndex: null, // 被换的index
      endIndexId: null, // 被换的indexId
      pageSizeOptions: ['10', '20', '30', '40', '50', '60', '70', '80'],
      current: 1,
      total: 0, // 总条数
      pageNum: 1,
      pageSize: '10',
      indexSort: [] // 排序列表传参
    }
  },
  filters: {},
  async created() {
    const dictTypes = ['train_type', 'train_release_status']
    getfinddictAll({ dictTypes: dictTypes.join() }).then(res => {
      this.trainType = res.train_type
      this.trainReleaseStatus = res.train_release_status
    })

    this.selectBrand = []
    getSelectBrand().then(res => {
      if (res.code === 0) {
        this.selectBrand = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.selectModel = []
    getSelectModel().then(res => {
      if (res.code === 0) {
        this.selectModel = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.getList()
  },
  methods: {
    // 获取列表信息
    async getList() {
      const { keyWord, type, brandId, modelId, releaseStatus, time1, time2, startTime, endTime } = this.queryParam
      try {
        var res = await queryList({
          keyWord,
          type,
          brandId,
          modelId,
          releaseStatus,
          time1,
          time2,
          startTime,
          endTime,
          pageSize: this.pageSize,
          pageNum: this.pageNum
        }) // 以上为查询条件
        this.loadData = res.rows
        this.total = res.total
      } catch (err) {
        console.log(err)
      }
    },
    // filterOption (input, option) {
    //   return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    // },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    handleEdit(row) {
      this.$refs.modal.edit(row)
    },
    handleInfo(row) {
      this.$refs.modal.edit(row, true)
    },
    handlePubulish(record) {
      record.releaseStatus = 1
      trainUpdate(record).then(res => {
        if (res.code === 0) {
          this.$message.success('发布成功!')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    cancel(record) {
      record.releaseStatus = 0
      trainUpdate(record).then(res => {
        if (res.code === 0) {
          this.$message.success('撤销成功!')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleOk() {
      this.getList()
    },

    // 品牌
    changeBrandName(e) {
      this.queryParam.brandId = e
    },

    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },

    onChange1(value, dateString) {
      this.queryParam.startTime = dateString
    },
    onChange2(date, dateString) {
      this.queryParam.endTime = dateString
    },
    // 拖拽排序
    customRow(record, index) {
      if (this.queryParam.type) {
        return {
          attrs: { draggable: true },
          style: {
            cursor: 'pointer'
          },

          on: {
            // 鼠标移入
            mouseenter: event => {
              // 兼容IE
              var ev = event || window.event
              ev.target.draggable = true
              // console.log(1, event, record)
            },
            // 开始拖拽
            dragstart: event => {
              // 兼容IE
              var ev = event || window.event
              // 阻止冒泡
              this.startIndexId = record.indexId
              ev.stopPropagation()
              this.startIndex = index + 0
            },
            // 拖动元素经过的元素
            dragover: event => {
              // 兼容 IE
              var ev = event || window.event
              // 阻止默认行为
              ev.preventDefault()
            },
            // 鼠标松开
            drop: event => {
              // 兼容IE
              var ev = event || window.event
              // 阻止冒泡
              ev.stopPropagation()
              // 得到目标数据
              this.endIndexId = record.indexId
              this.endIndex = index + 0
              // 进行调换
              this.loadData[this.endIndex].indexId = this.startIndexId
              this.loadData[this.startIndex].indexId = this.endIndexId
              this.loadData.splice(
                this.startIndex,
                1,
                ...this.loadData.splice(this.endIndex, 1, this.loadData[this.startIndex])
              )
              this.indexSort = this.loadData.map(item => {
                return {
                  trainId: item.trainId,
                  indexId: item.indexId
                }
              })
              updateIndexIdSort(this.indexSort).then(() => {
                console.log(this.loadData)
              })
            }
          }
        }
      }
    },
    // 分页
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.changePage(current)
    },
    // 改变页码
    changePage(value) {
      this.current = value
      this.pageNum = value
      this.getList()
    },
    // 查询
    query(page) {
      if (page == 1) {
        this.pageNum = 1
        this.current = 1
      }
      this.getList()
    },
    // 类型选择
    installChange(value) {
      this.queryParam.type = value
      this.getList()
    },
    // 删除
    async delTrain(trainId) {
      try {
        await delTrainList({
          trainId: trainId
        }).then(() => {
          this.getList()
        })
      } catch (err) {
        console.log(err)
      }
    }
  },
  watch: {}
}
</script>
<style scoped>
.tableItem {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 160px;
}

/deep/ .ant-table th {
  white-space: nowrap;
}

/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
